const styles = () => {
  const cssClass = {
    HIDE: 'qusd-utils-hide-element',
    HIDE_VISUALLY: 'screen-reader-text',
    NO_SCROLL: 'qusd-utils-no-scroll',
  };

  const numberToPixels = (number) => `${number}px`;

  const hideElement = (element, hideVisually = false) => {
    if (hideVisually) {
      element.classList.add(cssClass.HIDE_VISUALLY);
    } else {
      element.classList.add(cssClass.HIDE);
    }
  };

  const showElement = (element) => {
    element.classList.remove(cssClass.HIDE, cssClass.HIDE_VISUALLY);
  };

  return {
    numberToPixels,
    hideElement,
    showElement,
    cssClass,
  };
};

export default styles();
